import axios from "axios";
import { baseURL } from "../config/api";

export const post_UserLogin = (data: any) => {
    return axios({
        url: `${baseURL}authUsers/login`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}